import { render, staticRenderFns } from "./DeleteComment.vue?vue&type=template&id=f1b0642a&scoped=true"
import script from "./DeleteComment.vue?vue&type=script&lang=js"
export * from "./DeleteComment.vue?vue&type=script&lang=js"
import style0 from "./DeleteComment.vue?vue&type=style&index=0&id=f1b0642a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1b0642a",
  null
  
)

export default component.exports